<template>
    <v-app>
        <login-dialog
            :referal="config.referralSources"
            :sitekey="config.recaptchaKey"
            :next="next"
            :skip-captcha="skipCaptcha"
        />
        <signup-dialog
            :referal="config.referralSources"
            :google-id="config.googleAppId"
            :sitekey="config.recaptchaKey"
            :next="next"
            :skip-captcha="skipCaptcha"
        />
    </v-app>
</template>

<script>
import LoginDialog from "@/components/auth/LoginDialog.vue";
import SignupDialog from "@/components/auth/SignupDialog.vue";

export default {
    name: "AuthApp",
    components: {SignupDialog, LoginDialog},
    props: {
        next: {
            type: String,
            required: false,
        },
        skipCaptcha: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        config() {
            return {
                referralSources: global.config.referralSources,
                recaptchaKey: global.config.recaptchaKey,
                googleAppId: global.config.googleAppId,
            }
        }
    },
    created() {
        console.debug('Auth App created, next page: ', this.next);
    },
}
</script>

<style scoped>

</style>
